module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "loginContent"
  }, [_c('div', {
    staticClass: "login"
  }, [_c('el-tabs', {
    on: {
      "tab-click": _vm.selectLoginType
    },
    model: {
      value: (_vm.loginType),
      callback: function($$v) {
        _vm.loginType = $$v
      },
      expression: "loginType"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": "密码登录",
      "name": "0"
    }
  }, [_c('div', {
    staticClass: "loginUserName"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.name),
      expression: "form.name"
    }],
    attrs: {
      "type": "text",
      "placeholder": "请输入用户名"
    },
    domProps: {
      "value": (_vm.form.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "name", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "loginPassword"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.password),
      expression: "form.password"
    }],
    attrs: {
      "type": "password",
      "placeholder": "请输入密码"
    },
    domProps: {
      "value": (_vm.form.password)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.submitForm($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "password", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "loginCode"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.code),
      expression: "form.code"
    }],
    attrs: {
      "type": "text",
      "placeholder": "请输入验证码"
    },
    domProps: {
      "value": (_vm.form.code)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.submitForm($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "code", $event.target.value)
      }
    }
  }), _c('img', {
    attrs: {
      "src": _vm.codeUrl
    }
  }), _c('div', {
    on: {
      "click": _vm.refreshCaptcha
    }
  }, [_vm._v("刷新")])]), _vm._v(" "), _c('div', {
    staticClass: "loginRemember"
  }, [(!_vm.form.isRemember) ? _c('img', {
    attrs: {
      "src": "http://img.static.knnnj.com/Default/1b2fbf0b-a909-4d8a-932c-f66bb1850500-2.png"
    },
    on: {
      "click": function($event) {
        return _vm.remember(true)
      }
    }
  }) : _c('img', {
    attrs: {
      "src": "http://img.static.knnnj.com/Default/49625030-cb0b-4ca2-a757-fbef9598096e-2.png"
    },
    on: {
      "click": function($event) {
        return _vm.remember(false)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "rememberPassword"
  }, [_vm._v("记住密码")]), _vm._v(" "), _c('div', {
    staticClass: "forgetPassword",
    on: {
      "click": _vm.forget
    }
  }, [_vm._v("忘记密码？")])])]), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "短信登录",
      "name": "1"
    }
  }, [_c('div', {
    staticClass: "loginMobile"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.mobile),
      expression: "form.mobile"
    }],
    attrs: {
      "type": "text",
      "placeholder": "请输入手机号码"
    },
    domProps: {
      "value": (_vm.form.mobile)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "mobile", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "loginCode"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.code),
      expression: "form.code"
    }],
    attrs: {
      "type": "text",
      "placeholder": "请输入验证码"
    },
    domProps: {
      "value": (_vm.form.code)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.submitForm($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "code", $event.target.value)
      }
    }
  }), _c('img', {
    attrs: {
      "src": _vm.codeUrl
    }
  }), _c('div', {
    on: {
      "click": _vm.refreshCaptcha
    }
  }, [_vm._v("刷新")])]), _vm._v(" "), _c('div', {
    staticClass: "loginShortMsgCode"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.form.shortMsgCode),
      expression: "form.shortMsgCode",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "shortMsgCode",
    attrs: {
      "type": "text",
      "placeholder": "请输入短信验证码"
    },
    domProps: {
      "value": (_vm.form.shortMsgCode)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.submitForm($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "shortMsgCode", $event.target.value.trim())
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), (!_vm.isSendMsg) ? _c('div', {
    staticClass: "sendbtn",
    on: {
      "click": _vm.toSendMsg
    }
  }, [_vm._v(" " + _vm._s(_vm.shortMsgCodeContent))]) : _c('div', {
    staticClass: "sendbtn1"
  }, [_vm._v(" " + _vm._s(_vm.shortMsgCodeContent) + "(" + _vm._s(_vm.countDown) + ")")])])]), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "微信登录",
      "name": "2"
    }
  }, [_c('div', {
    staticClass: "weixinLogin"
  }, [_c('div', {
    ref: "qrcodeContainer"
  })]), _vm._v(" "), _c('div', {
    staticClass: "weixinLoginMemo"
  }, [_vm._v("请用微信扫描二维码登录系统")])])], 1), _vm._v(" "), (_vm.loginType != '2') ? _c('div', {
    staticClass: "loginBtn"
  }, [_c('input', {
    attrs: {
      "type": "button",
      "value": "登录"
    },
    on: {
      "click": _vm.submitForm
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.loginType != '2') ? _c('div', {
    staticClass: "loginRegister"
  }, [_vm._v("没有账号？"), _c('span', {
    on: {
      "click": _vm.toRegister
    }
  }, [_vm._v("立即注册")])]) : _vm._e()], 1), _vm._v(" "), _c('forgetPassword', {
    ref: "forgetPassword",
    on: {
      "fetch-data": _vm.refreshCaptcha
    }
  }), _vm._v(" "), _c('bindingUser', {
    ref: "bindingUser",
    on: {
      "bindingLogin": _vm.bindingLogin
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d9fa8822","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/user/Login.vue
// module id = 784
// module chunks = 2